import { render, staticRenderFns } from "./ErrorNotFound.vue?vue&type=template&id=18c3647c&scoped=true&"
import script from "./ErrorNotFound.vue?vue&type=script&lang=ts&"
export * from "./ErrorNotFound.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorNotFound.vue?vue&type=style&index=0&id=18c3647c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c3647c",
  null
  
)

export default component.exports